<div *ngIf="progressSteps.currentStep === steps.validateVerificationToken" >
    <div class="form-title">
    </div>
</div>

<div *ngIf="progressSteps.currentStep === steps.passwordMatch" [formGroup]="passwordMatchForm" class="marlinFormGroup">
    <div class="form-title">
        <h2 [innerHTML]='message | translate'></h2>
        <p *ngIf='passwordResetType == passwordResetTypes.updatePassword' [innerHTML]='"lclChangePassword" | translate'>
        </p>
    </div>
    <marlin-input-password *ngIf='passwordResetType == passwordResetTypes.updatePassword' [label]="'lclOldPassword'" [errorMessage]="'gblPasswordRequiredErrorMsg'"
        formControlName="oldPassword"></marlin-input-password>
    <marlin-password (onPasswordChange)="passwordMatchForm.controls.password.setValue($event.controls.password.value); passwordMatchForm.controls.confirmPassword.setValue($event.controls.confirmPassword.value); passwordMatchForm.setErrors($event.valid ? null : {error: true})"></marlin-password>
    <div class="mb-3">
        <button class="btn btn-primary w-100" (click)="submitPasswordChange()">{{"gblGo" | translate}}</button>
    </div>
    <div class="mb-3 text-center form-navigation">
        <marlin-home-button></marlin-home-button>
    </div>
</div>

<div class="mb-3" *ngIf="progressSteps.currentStep === steps.passwordUpdateSucccess" class="marlinFormGroup">
    <div class="form-title">
        <h2 [innerHTML]='"gblPasswordUpdated" | translate'></h2>
        <button *ngIf="passwordResetType != passwordResetTypes.updatePassword" class="btn btn-primary w-100" [routerLink]="['/portal/home']">{{"lclClickHereToLogIn" | translate}}</button>
        <button *ngIf="passwordResetType == passwordResetTypes.updatePassword" class="btn btn-primary w-100" [routerLink]="['/portal/home']">{{"gblHomePage" | translate}}</button>
    </div>
</div>

<div *ngIf="progressSteps.currentStep === steps.validateVerificationFailedNoResendOption" class="marlinFormGroup"> 
    <div class="form-title">
        <h2 [innerHTML]='"gblUnableToCompleteYourRequest" | translate'></h2>
    </div>
    <div class="mb-3">
       <label [innerHTML]='"gblVerificationLinkExpired" | translate'></label>
    </div>

    <div class="mb-3 row marginspecified">
        <div class="col text-left">
            <a [routerLink]="['/support']" [queryParams]="{type:'PasswordReset'}" [innerHTML]="'gblNeedHelp' | translate"></a>
        </div>
        <div class="col text-center">
            <a [routerLink]="['/portal/home']" [innerHTML]="'gblLogin' | translate"></a>
        </div>
    </div>
</div>

<div *ngIf="progressSteps.currentStep === steps.validateVerificationFailed" class="marlinFormGroup">
    <div class="form-title">
        <h2 [innerHTML]='"gblUnableToCompleteYourRequest" | translate'></h2>
    </div>

    <div class="mb-3">
        <label [innerHTML]='"gblVerificationTokenExpired" | translate'></label>token expired
    </div>

    <div class="mb-3">
        <button class="btn btn-outline-primary w-100" (click)="resendVerificationEmail();" [innerHTML]="'gblGenerateToken' | translate"></button>
    </div>

    <div class="row">
        <div class="col text-center">
            <a [routerLink]="['/support']" [queryParams]="{type:'PasswordReset'}" [innerHTML]="'gblNeedHelp' | translate"></a>
        </div>
        <div class="col text-center">
            <a [routerLink]="['/portal/home']" [innerHTML]="'gblLogin' | translate"></a>
        </div>
    </div>
</div>

<div *ngIf="progressSteps.currentStep === steps.resendVerificationEmail" class="mb-3" class="marlinFormGroup">
    <div class="form-title">
        <h4 [innerHTML]='"gblFurtherInstructionsSent" | translate'></h4>
    </div>
    <div class="mb-3 text-center form-navigation">
        <marlin-home-button></marlin-home-button>
    </div>
</div>

<div *ngIf="progressSteps.currentStep === steps.serverError" class="marlinFormGroup">
    <ng-container *ngIf="passwordResetType == passwordResetTypes.updatePassword; then passwordUpdate; else passwordReset"></ng-container>

    <ng-template #passwordUpdate>
        <div class="mb-3">
            <div class="form-title">
                <h2 [innerHTML]='"pmtResetPassword" | translate'></h2>
            </div>
            <div>
                <button class="btn btn-primary w-100" (click)="resetPage();" [innerHTML]="'gblTryAgain' | translate"></button>
            </div>
            <div class="mb-3 row">
                <div class="col text-center">
                    <a [routerLink]="['/support']" [queryParams]="{type:'PasswordReset'}">{{'gblNeedHelp' | translate}}</a>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #passwordReset>
        <div class="form-title">
            <h2 [innerHTML]='"gblUnableToCompleteYourRequest" | translate'></h2>
        </div>

        <div *ngIf="passwordResetType === passwordResetTypes.completeRegistration">
            <div class="mb-3 marlinFormGroup">
                <button class="btn btn-primary w-100 button-inherit" target="_blank" [routerLink]="['/support']" [queryParams]="{type:'AccountRegistration'}" [innerHTML]="'gblContactOurTeam' | translate"></button>
            </div>
        </div>

        <div *ngIf="passwordResetType === passwordResetTypes.resetPassword">
            <div class="mb-3">
                <button class="btn btn-primary w-100" [routerLink]="['/forgot-password']" [innerHTML]="'gblTryAgain' | translate"></button>
            </div>
            <div class="mb-3 row">
                <div class="col text-center">
                    <a [routerLink]="['/support']" [queryParams]="{type:'PasswordReset'}" [innerHTML]="'gblNeedHelp' | translate"></a>
                </div>
                <div class="col text-center">
                    <a [routerLink]="['/portal/home']" [innerHTML]="'gblLogin' | translate"></a>
                </div>
            </div>
        </div>
    </ng-template>
</div>